import React from 'react';
import { Form, Select } from 'antd';

type BillingConfigType = {
  id: string;
  name: string;
};

export function BillingConfigSelect({
  billingConfigs,
  required = false,
}: {
  billingConfigs: BillingConfigType[];
  required?: boolean;
}) {
  return (
    <Form.Item
      colon={false}
      required={required}
      name="worksBillingConfigId"
      label="Billing Configuration"
    >
      <Select
        size="large"
        placeholder="Select a billing configuration..."
        getPopupContainer={(trigger) => trigger.parentNode}
      >
        {billingConfigs.map(({ id, name }) => {
          return (
            <Select.Option key={id} value={id}>
              {name}
            </Select.Option>
          );
        })}
      </Select>
    </Form.Item>
  );
}
